/**
 * Per-account, in-memory cache of the dashboard's Trade Opportunities cards
 * (Stage 3, 2026-10-31). Holds ONE list for ONE account id, in module scope
 * only: nothing is persisted, the cards are public listing data (no
 * transaction records), and anything for another account is dropped the
 * moment a different uid reads or writes. The dashboard shows the cached
 * cards at once on a return visit and refreshes them behind; a refresh that
 * fails is reported through the section's failed state, not papered over
 * with the old cards.
 */
const cache = { uid: null, pedals: [] };

export function readRecommendedCache(uid) {
  if (!uid || cache.uid !== uid) return [];
  return cache.pedals;
}

export function writeRecommendedCache(uid, pedals) {
  if (!uid) { cache.uid = null; cache.pedals = []; return; }
  cache.uid = uid;
  cache.pedals = Array.isArray(pedals) ? pedals : [];
}

export function clearRecommendedCache() {
  cache.uid = null;
  cache.pedals = [];
}
